export default __webpack_public_path__ + "static/naves_4-f5629e886a3c306d9d6b7e66d12883d0.jpg";